import script from "./IconComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./IconComponent.vue?vue&type=script&setup=true&lang=js"

import "./IconComponent.vue?vue&type=style&index=0&id=1bfbc9b1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfbc9b1"]])

export default __exports__